const { default: ApiService } = require("./api.service");

const DoctorService = {

    uploadProfilePicture: (file) => {
        console.log('Uploading file:', file); // debug
        const formData = new FormData();
        formData.append('profile_picture', file);

        return ApiService.fetch('therapist/profile-picture', {
            method: 'POST',
            body: formData,
            // Non mandare headers per FormData
            headers: {}
        });
    },

    getProfile: () => ApiService.fetch('therapist/profile'),

    getAll: () =>ApiService.fetch('doctors/all'),

    getSuggested: () => ApiService.fetch('doctor/suggest'),

    updateProfile: (data) => ApiService.fetch('therapist/profile', {
        method: 'PUT',
        body: JSON.stringify({
            ...data,
            phone: data.phone,
            commission_rate: data.commission_rate
        })
    }),

    updatePassword: (passwordData) => ApiService.fetch('therapist/update-password', {
        method: 'POST',
        body: JSON.stringify(passwordData)
    }),
};

export default DoctorService;